import { render, staticRenderFns } from "./perm.vue?vue&type=template&id=2d4067d0&scoped=true&"
import script from "./perm.vue?vue&type=script&lang=ts&"
export * from "./perm.vue?vue&type=script&lang=ts&"
import style0 from "./perm.vue?vue&type=style&index=0&id=2d4067d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4067d0",
  null
  
)

export default component.exports